'use client';

import { Box } from '@mantine/core';
import Image from 'next/image';
import medium from '@/../public/icons/social/medium.svg';
import twitter from '@/../public/icons/social/twitter.svg';
import youtube from '@/../public/icons/social/youtube.svg';
import LogoLight from '@/../public/Arcanis_Logo_White.png';
import LogoDark from '@/../public/Arcanis_Logo_Dark.png';
import { BottomMenuLink } from '@/shared/BottomMenuLink';
import { UserConsentModal } from '@/features/userConsent/userConsentModal';
import { useDisclosure } from '@mantine/hooks';
import { useAppDispatch, useAppSelector } from '@/hooks/reduxHooks';
import { showConsentModal } from '@/features/userConsent/userConsentSlice';
import { modalState } from '@/features/privacyPolicy/privacyPolicySlice';

type Props = {
  mt?: boolean;
};

export const Footer = ({mt = true}: Props) => {
  const theme = useAppSelector((state) => state.theme.theme);
  const dispatch = useAppDispatch();
  const [opened, { open, close }] = useDisclosure(false);
  const socialLogos = [twitter, youtube, medium];
  /* const menuItems = [
    "Home",
    "Products",
    "Indexes",
    "Strategies",
    "Strategy Holders",
    "Securitization",
    "Team",
    "Contacts",
  ]; */
  const menuItems: any[] = [];

  return (
    <Box className={`${mt ? 'mt-20' : ''} flex h-full w-full flex-col bg-secondary-300/10 px-[120px] text-secondary-500 xxs:max-md:px-[20px] xl:px-[240px] dark:text-lightBlue-200`}>
      <UserConsentModal />
      <Box
        id="topSection"
        className="mt-20 flex items-start justify-between xxs:max-md:flex-col"
      >
        <Box id="contacts" className="flex flex-col items-start">
          <Image
            priority
            src={theme === 'light' ? LogoDark : LogoLight}
            alt="Arcanis Capital Logo"
            className="w-40"
            quality={100}
          />
          <p className="mt-6 text-secondary-300 dark:text-lightBlue-500">
            Cheilonos, 2A The Riverside Forum, <br /> 2nd floor, 1101 Nicosia,{' '}
            <br /> Cyprus
          </p>
          <Box id="socialNetworks" className="mt-6 hidden">
            {socialLogos.map((Item, index) => (
              <Box
                key={index}
                className="mr-6 flex h-10 w-10 items-center justify-center rounded-full bg-lightBlue-500/20 hover:bg-primary-500/60"
              >
                <Item className="h-4 w-4" />
              </Box>
            ))}
          </Box>
        </Box>
        <Box
          id="menu"
          className="flex items-end justify-between gap-4 xxs:max-md:hidden"
        >
          {menuItems.map((menuItem, index) => (
            <BottomMenuLink key={index} page={menuItem} />
          ))}
        </Box>
      </Box>
      <Box
        id="bottomSection"
        className="mb-20 mt-20 flex w-full items-start justify-between text-sm text-secondary-500/50 xxs:max-md:flex-col xxs:max-md:gap-8 xxs:max-md:text-xs dark:text-lightBlue-200/50"
      >
        <Box className="flex xxs:max-md:w-full xxs:max-md:justify-between">
          <p className="mr-6">Copyright © 2024 Arcanis Capital</p>
          <p className="">All rights reserved</p>
        </Box>
        <Box className="flex gap-6 xxs:max-md:w-full xxs:max-md:justify-between">
          <p
            className="cursor-pointer"
            onClick={() => dispatch(modalState(true))}
          >
            Privacy Policy
          </p>
          <p
            className="cursor-pointer"
            onClick={() => dispatch(showConsentModal(true))}
          >
            Legal Notice
          </p>
        </Box>
      </Box>
    </Box>
  );
};
